var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguagecard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.908203,
    y: 0.813965,
    width: 32.5322,
    height: 32.5322,
    rx: 10,
    fill: "#FB8500",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.689 19.0774L16.1866 17.4443L16.2044 17.4248C17.2064 16.1997 17.9551 14.7501 18.3988 13.1761H20.1319V11.8748H15.9914V10.5735H14.8084V11.8748H10.668V13.1761H17.275C16.8787 14.4253 16.2517 15.616 15.3999 16.657C14.8498 15.9868 14.3944 15.2516 14.0336 14.4773H12.8506C13.2824 15.5379 13.8739 16.5399 14.6132 17.4443L11.6025 20.7105L12.4425 21.6344L15.3999 18.3812L17.2395 20.4047L17.689 19.0774ZM21.0191 15.7786H19.8361L17.1744 23.5864H18.3574L19.0199 21.6344H21.8295L22.4979 23.5864H23.6808L21.0191 15.7786ZM19.4694 20.3331L20.4276 17.5159L21.3858 20.3331H19.4694Z",
    fill: "#FB8500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagecard);
export default __webpack_public_path__ + "static/media/languagecard.6e823ab22c5c909cc01bf52b7118c40c.svg";
export { ForwardRef as ReactComponent };